import { config } from "../../../config";
import { pathJoin, sharedLinkPath } from "../../paths";

export function shareCodeToLink(code: string): string {
  return pathJoin(`https://${config.sharingDomain}`, sharedLinkPath(code));
}
